import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { RegisterService } from "../services/register.service";
import { environment } from "../environments/environment.prod";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
})
export class SuccessComponent implements OnInit {
  private countryCode = "de";
  newsletterImage = "";
  stickImage = "";
  fieldLabel;
  fieldLabel2;
  amcUnsubFormLabel: FormGroup;
  translateData = [];
  language = { key: ["de"] };

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private registerService: RegisterService,
    private route: ActivatedRoute
  ) {
    this.stickImage = environment.stickImage;
  }

  ngOnInit() {
    // get language param from route
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.countryCode = params.get("lang");
    });

    if (this.countryCode == null) {
      this.countryCode = "de";
    }

    this.loadTranslateDataFromDB(this.countryCode);

    /**
     * Definition of form field-labels for frontend
     */

    this.amcUnsubFormLabel = this.formBuilder.group({
      nl_heading: ["AMC News"],
      nl_success: ["Erfolgreich abgeschickt."],
      nl_success_mail_1: ["Vielen Dank für Ihre Anmeldung zu den AMC News."],
      nl_success_mail_2: [
        "Sie erhalten in Kürze eine E-Mail, um Ihre Anmeldung zu bestätigen.",
      ],
    });
  }

  getFieldLabel(Label) {
    this.fieldLabel2 = this.amcUnsubFormLabel.get(Label);
    return this.fieldLabel2 != null ? this.fieldLabel2.value : "";
  }

  /**
   * Get translated data from the database from register.service.ts
   * @param language
   */
  loadTranslateDataFromDB(language) {
    this.translateData = [];
    this.language.key = language;
    this.registerService.loadTranslateDataFromDB(this.language.key).subscribe(
      (data) => {
        this.translateData = data;
        this.setTranslate();
      },
      (error) => {
        this.router.navigate(["./" + this.countryCode + "/error/error"]);
      }
    );
  }

  /**
   * Set labels with translated texts from the database
   */
  setTranslate() {
    this.translateData.forEach((obj) => {
      this.fieldLabel = this.translateData.find((k) => k.key === obj.key);
      if (
        this.fieldLabel != null &&
        this.amcUnsubFormLabel.get(obj.key) != null
      ) {
        this.amcUnsubFormLabel.controls[obj.key].setValue(this.fieldLabel.text);
      }
    });
  }
}
